export default __webpack_public_path__ + "static/media/banner_family_day.cf46ba93.jpg";